var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:'tw-font-medium ' + _vm.color[1]},[_vm._v(_vm._s(_vm._defaultIncoming(_vm.item)))])
}
var staticRenderFns = []

export { render, staticRenderFns }